<script setup>

</script>

<template>

    <section class="mt-6 md:mt-5 md:grid md:grid-cols-3 md:gap-8">
        <div class="md:col-span-1">
            <header class="px-4 sm:px-0">
                <h3 class="mt-0 p-0 font-medium leading-5 text-gray-700 text-base text-left">

                    <slot name="title"></slot>

                </h3>
                <p class="mt-2 text-sm text-gray-500">

                    <slot name="description"></slot>

                </p>
            </header>
        </div>
        <div class="mt-6 md:col-span-2 md:mt-0">
            <div class="rounded-md border border-gray-200 bg-white">
                <div class="p-6">
                    <div class="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">

                        <slot name="inputs"></slot>

                    </div>
                </div>
            </div>
        </div>
    </section>

</template>

<style scoped>

</style>